<template>
   <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col copyright">
          <p><i class="fa-icon fa-regular fa-copyright"></i> Copyright 2024 v 00.00.28</p>
        </div>
        <div class="col text-link">
          <ul class="list-inline">
            <li class="list-inline-item"> <router-link to="article">บทความ</router-link></li>
            <li class="list-inline-item"> <a href="javascript:;" @click="openLine()">ติดต่อเรา</a></li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapState({
      hasBank: state => state.bankModule.hasBank,
      isGamePermission: (state) => state.authModule.isGamePermission,
      isMember: (state) => state.authModule.isMember
    }),
    ...mapGetters(['getLine', 'getLogo2'])
  },

  data () {
    return {
      AGENT_S_BASE: process.env.VUE_APP_AGENT_BASE,
      casinoEnable: process.env.VUE_APP_CASINO_ENABLE.toLowerCase().trim(),
      AGENT_EXT_NAME: process.env.VUE_APP_EXT_NAME
    }
  },
  methods: {
    openLine () {
      window.open(this.getLine)
    },
    pushRoute (route) {
      this.$router.replace(route)
      this.setIsActive(false)
    },
    openRegister () {
      this.$bvModal.hide('modal-user-login')
      this.$bvModal.show('modal-user-register')
    }
  }
}
</script>

<style>

</style>
